class SideNav {
	init() {
		const sideNavs = Array.from(document.querySelectorAll<HTMLElement>(".side-nav"));
		const sideNavHrefs = sideNavs.map(sideNav => Array.from(sideNav.querySelectorAll("a[href^='#']")).map(anchor => anchor.getAttribute("href")))
			.reduce((prev, curr) => [...prev, ...curr], []);
		const pageAnchors = Array.from(document.querySelectorAll<HTMLElement>("[id]"))
			.filter(pageAnchor => sideNavHrefs.some(sideNavHref => sideNavHref === pageAnchor.id));

		if ((pageAnchors?.length ?? 0) <= 0) {
			return;
		}

		window.addEventListener("scroll", () => {
			const activeAnchor = pageAnchors.filter(pageAnchor => pageAnchor.getBoundingClientRect().top < 100).sort((a, b) => {
				const aTop = a.getBoundingClientRect().top;
				const bTop = b.getBoundingClientRect().top;

				if (aTop > bTop) {
					return 1;
				}
				if (aTop === bTop) {
					return 0;
				}

				return -1;
			})[0];

			if (!activeAnchor) {
				return;
			}

			sideNavs.forEach(sideNav => {
				if (sideNav.getAttribute("href") === activeAnchor.id) {
					sideNav.classList.add("active");
				} else {
					sideNav.classList.remove("active");
				}
			});
		});
	}
}

document.addEventListener("DOMContentLoaded", () => {
	const sideNav = new SideNav();

	sideNav.init();
});
